import { useIntl } from 'react-intl';

import AddParentBlock from '@components/automations/AddParentBlock';
import TertiaryButton from '@components/buttons/TertiaryButton';
import Tag from '@components/labels/Tag';
import Nbsp from '@components/Nbsp';
import Icon from '@components/text/Icon';
import Heading3 from '@components/typography/Heading3';
import useMyExpert from '@hooks/useMyExpert';
import { Selection } from '@typing/Automations';
import { AutomationFragment as AutomationType } from '@typing/Generated';

type Block = NonNullable<AutomationType['blocks'][number]>;

type Props = {
  automation: AutomationType;
  onBlockAdded: (block: Block) => void;
  selection: Selection;
};

const AutomationTerminatorBlockPanel = ({ automation, onBlockAdded, selection }: Props) => {
  const intl = useIntl();
  const myExpert = useMyExpert();

  return (
    <>
      <Heading3>
        {automation.title}
        {automation.locked && (
          <>
            <Nbsp />
            <Icon ariaLabelKey="accessibility.ariaLabels.locked" icon="lock" />
          </>
        )}
      </Heading3>
      <div>
        {automation.live ? (
          <Tag color="secondary500" text={intl.formatMessage({ id: 'models.automation.live' })} />
        ) : (
          <Tag color="primary300" text={intl.formatMessage({ id: 'models.automation.draft' })} />
        )}
      </div>
      <div>
        <TertiaryButton
          icon="edit"
          routerLink={`/${myExpert ? 'expert' : 'admin'}/automations/${automation.id}/edit`}
          textKey={'dictionary.edit'}
        />
      </div>
      <AddParentBlock
        automation={automation}
        onBlockAdded={onBlockAdded}
        parentBlockId={selection?.terminator?.parentBlock.id}
        parentBlockOutput={selection?.terminator?.parentOutput}
      />
    </>
  );
};

export default AutomationTerminatorBlockPanel;
